//node_modules
import { FunctionComponent, PropsWithChildren, useMemo } from "react";

//libs
import { cx, css } from "@adjust/libs/emotion";

type CONTAINER_SIZES = "xs" | "sm" | "md" | "lg" | "xl";

function calculateMaxWidth(size: CONTAINER_SIZES) {
  switch (size) {
    case "xs":
      return "576px";
    case "sm":
      return "768px";
    default:
    case "md":
      return "992px";
    case "lg":
      return "1200px";
    case "xl":
      return "1400px";
  }
}

function useClassName(size: CONTAINER_SIZES) {
  const className = useMemo(() => {
    return css({
      width: "100%",
      maxWidth: calculateMaxWidth(size),
      paddingRight: "0.75em",
      paddingLeft: "0.75em",
      marginRight: "auto",
      marginLeft: "auto",
    });
  }, [size]);
  return className;
}

type ContainerProps = {
  size: CONTAINER_SIZES;
};

const SizedContainer: FunctionComponent<PropsWithChildren<ContainerProps>> = ({ size, children }) => {
  const className = useClassName(size);

  return <div className={className}>{children}</div>;
};

export default SizedContainer;
